import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { IResult, IResultOfType, ISharePointConfigurationItem, ISharePointConnectionInfoHolder } from "../models/auto-generated";

@Injectable({
  providedIn: "root"
})
export class SharePointConnectionService {
  private getBaseRoute(instanceId: string): string {
    return `/api/configurations/${instanceId}/sharepoint`;
  }
  constructor(private http: HttpClient) {}

  getConnection(instanceId: string, connectionId: number): Observable<ISharePointConnectionInfoHolder> {
    const baseRoute = this.getBaseRoute(instanceId);
    return this.http.get<ISharePointConnectionInfoHolder>(`${baseRoute}/${connectionId}`);
  }

  createConnection(instanceId: string, connectionName: string): Observable<any> {
    const baseRoute = this.getBaseRoute(instanceId);
    return this.http.post<ISharePointConfigurationItem>(baseRoute, {
      ConnectionName: connectionName
    });
  }

  updateConnection(instanceId: string, connectionId: number, connection: ISharePointConnectionInfoHolder): Observable<any> {
    const baseRoute = this.getBaseRoute(instanceId);
    return this.http.put<any>(`${baseRoute}/${connectionId}`, connection);
  }

  deleteConnection(instanceId: string, connectionId: number): Observable<IResult> {
    const baseRoute = this.getBaseRoute(instanceId);
    return this.http.delete<IResult>(`${baseRoute}/${connectionId}`);
  }

  testConnection(instanceId: string, connection: ISharePointConnectionInfoHolder, connectionId?: number): Observable<IResultOfType<string>> {
    const baseRoute = this.getBaseRoute(instanceId);
    const url = connectionId ? `${baseRoute}/${connectionId}/test` : `${baseRoute}/test`;
    return this.http.post<IResultOfType<string>>(url, connection);
  }
}
